export default {

  // 时间转换
  formatDate (value, type) {
    let date = new Date(value * 1000)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s

    if (type == null) {
      type = 'YYMMDDhhmmss'
    }

    var formatStr = ''
    if (type === 'YYMMDD') {
      formatStr = y + '-' + MM + '-' + d
    } else if (type === 'YYMMDDhhmmss') {
      formatStr = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    }
    return formatStr
  }

}



// WEBPACK FOOTER //
// ./src/js/Utils.js